const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS40MTQgMTJsNy4yOTMgNy4yOTMtMS40MTQgMS40MTRMNi41ODYgMTJsOC43MDctOC43MDcgMS40MTQgMS40MTR6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4K";
export {
  M as default
};
//# sourceMappingURL=arrow_left-7be42655.mjs.map
